var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _g2, _g3, _g4, _path67, _g5, _g6, _path68, _path69, _path70, _g7, _path71, _g8, _g9, _g0, _g1, _g10, _g11, _path72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.87 158.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1074.46,151.33c12.8-10.94,25.55-23.13,38-42,36.27-53.56,42.55-121.85,69.56-222.67,13.2-49.26,28.08-69.16,50.67-138.67,20.67-63.61,48.67-115.89,55.78-230.28",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.35,91c-15.78,4.22-32.67,14-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.24,70.56c5.56,12.89,8.22,32.67,2,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.35,18.11c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.13-41.11c-14.06,4.89-37.44,25-45.39,39.39",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.68-108c-15.11,4.44-42.77,30.02-50.89,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.16-201.29c6.22,13.11,12.44,38,13.33,56.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.82-108.85c7.76,11.69,20.15,44.64,19.56,64.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.57-26.11c6.89,22.22,20.67,40.22,17.78,70",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.02,102.89c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.13,100.11c-17.22-15.94-24.89-42.72-16.78-75.39,22.78,26.67,26.11,54.56,16.78,75.39Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.91,31.11c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.16-214.85c-14.17.83-46.56,18.56-55.67,32.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.23-301.14c-14.94,7.73-35.89,25.23-44.74,36.62",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.49-206.01c32.83,8.83,52.61-4.72,59.5-22.5-25.83-2.17-48.39-.17-59.5,22.5Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M874.49-120.18c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M853.89-106.5c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M516.73-144.31c19.32-15.86,18.64-45.75,10.95-57.47-12.34,14.53-19.76,41.13-10.95,57.47Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M535.24-108.92c-11.9,7.87-27.3,23.76-29.14,32.16",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M519.73-95.85c20.49-.8,34.84-20.68,35.61-32.15-15.26,3.39-33.28,17.11-35.61,32.15Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M901.82-201.51c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M881.22-187.83c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M909.58-283.51c-10.25,9.46-22.64,27.19-23.1,35.59",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M896.66-268.47c19.65-3.98,30.39-25.4,29.35-36.59-14.2,5.65-29.44,21.71-29.35,36.59Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.63-402.54c-12.66,3.81-34.81,21.26-41.14,32.69",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.47-392.02c24.47,6.87,40.37-10.6,43.64-26.31-20.67,2.02-38.16,6.84-43.64,26.31Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.42-449.9c-7.61,5.64-21.6,24.39-24.43,33.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.86-435.96c21.58-7.05,29.1-25.6,26.46-38.05-15.23,8.22-28.52,21.32-26.46,38.05Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.13,3.44c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.91-278.31c5.16,16.64,9.49,32.4,7.33,54.7",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.72-433.79c6.39,14.63,12.85,34.79,10.29,57.74",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.16-348.62c6.39,14.63,12.09,29.62,9.53,52.57",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.91-253.83c-17.23-12.98-22.66-44.25-18.67-62.22,22.97,22.72,23.16,47.49,18.67,62.22Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M715.71,156.27c12.8-10.94,35.64-27.17,48.08-46.04,36.27-53.56,47.76-118.56,76.25-218.96,14-49.33,60-118,47.01-198.91",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25,156.37c79.1-41.85,121.4-149.58,142.42-232.27,7.44-30.33,12.86-61.2,15.43-92.31.08-.96.92-1.67,1.87-1.59.96.08,1.67.91,1.59,1.87-2.46,31.35-7.78,62.41-15.15,92.95-21.01,84.13-63.5,192.97-143.9,235.81-2.91,1.38-5.26-2.79-2.26-4.46h0Z",
    fill: "#7db5a9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M807.68,91.89c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M749.05,81.6c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M833.68,19c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M859.93-45.62c-12.12.62-39.86,29.64-48.44,44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M456.57-20.78c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M831.91-169.22c6.89,22.22,14.03,24.04,11.14,53.82",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M866.24-242.89c6.89,22.22,8.36,24.71,5.47,54.49",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M779.35,103.78c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M479.24,74.56c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M450.91,86.44c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M105.49,91.44c-15.96,3.46-32.07,12.99-45.14,22.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78.21,102.89c29.34,3.64,50.74-6.79,62.46-28.24-25.57-3.5-47.39,6.32-62.46,28.24Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M752.38,108.93c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M421.05,64.71c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M424.38,92.04c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.63,87.94c2.23,10.26,4.61,19.89,0,34.64",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M54.18,108.82c-12.62-18.52-17.2-29.63-9.88-52.57,15.97,20.7,17.6,37.41,9.88,52.57Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M812.24,32c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M515.46-20.36c-13.29,7.39-30.36,21.29-38.49,35.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M494.97-5.9c30.66,1.64,46.57-18.86,52.2-37.07-26.55,2.53-42.7,13.68-52.2,37.07Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,66.07c25.4-17.26,25.65-43.21,19.1-61.11-19.6,18.09-25.7,36.75-19.1,61.11Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M468.13,8.78c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M777.91,6.78c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M789.46,36.33c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M802.18-65.18c5.97,12.06,13.12,21.51,14.2,38.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M796.84-114.96c5.94,7.86,17.76,29.34,16.43,54.23",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M828.51-220.96c5.94,7.86,12.96,32.26,14.09,56.01",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M811.49-49.37c-14.72-7.79-23.58-26.48-22.74-40.67,20.3,14.51,24.36,28.89,22.74,40.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M839.38-149.18c-17.43-6.7-25.04-32.63-21.63-47.86,24.09,15.19,26.07,36.58,21.63,47.86Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M489.78-95.19c4.39,22.85,11.29,25.45,5.13,54.72",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M494.99-74.44c-16.58-8.59-21.28-35.2-16.21-49.96,22.27,17.76,21.87,39.24,16.21,49.96Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M871.04-223.8c-14.04-8.37-17.84-33.59-13.43-47.46,18.8,17.12,18.32,37.41,13.43,47.46Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.68-104.69",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1237.81-147.32",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.41-120.61l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.6-120.12l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.04-107.45",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.1-120.27l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.58-120.35l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.08-120.2l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.41-120.61l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1237.74,
    y1: -120.5,
    x2: 1224.52,
    y2: -118.94,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.81-119.87l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8,0,0,13.43.21,13.43.21.74,0,.87,1.1.15,1.27h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1239.18,
    y1: -121.83,
    x2: 1231.25,
    y2: -132.21,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.68-121.44l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93,0,0,6.53,11.45,6.53,11.45.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1239.07,
    y1: -121.39,
    x2: 1233.69,
    y2: -107.1,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.67-121.16l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7,0,0,7.04-13.67,7.04-13.67.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1239.96,
    y1: -120.06,
    x2: 1249.36,
    y2: -107.87,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.47-120.45l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95,0,0-7.99-13.27-7.99-13.27-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1240.07,
    y1: -121.94,
    x2: 1247.02,
    y2: -133.32,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.53-122.28l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52,0,0-8.47,10.45-8.47,10.45-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1241.96,
    y1: -121.06,
    x2: 1254.85,
    y2: -120.5,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.99-121.69l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82,0,0-12.81-2.33-12.81-2.33-.73-.12-.68-1.22.06-1.28h0Z",
    fill: "#7db5a9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1301.43-342.43",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.02-315.72l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.21-315.23l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.65-302.56",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.71-315.39l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.19-315.47l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.69-315.32l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.02-315.72l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1301.35,
    y1: -315.61,
    x2: 1288.13,
    y2: -314.06,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.43-314.98l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8,0,0,13.43.21,13.43.21.74,0,.87,1.1.15,1.27h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1302.8,
    y1: -316.94,
    x2: 1294.86,
    y2: -327.32,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.29-316.56l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93,0,0,6.53,11.45,6.53,11.45.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1302.68,
    y1: -316.5,
    x2: 1297.3,
    y2: -302.21,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.28-316.27l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7,0,0,7.04-13.67,7.04-13.67.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1303.57,
    y1: -315.17,
    x2: 1312.97,
    y2: -302.99,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.08-315.56l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95,0,0-7.99-13.27-7.99-13.27-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1303.68,
    y1: -317.06,
    x2: 1310.64,
    y2: -328.43,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.14-317.39l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52,0,0-8.47,10.45-8.47,10.45-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1305.57,
    y1: -316.17,
    x2: 1318.46,
    y2: -315.61,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.6-316.81l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82,0,0-12.81-2.33-12.81-2.33-.73-.12-.68-1.22.06-1.28h0Z",
    fill: "#7db5a9"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1215.61-401.04",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.97-376.55l-6.24-23.5c-14.61-13.02-30.49,5.85-18.03,16.88l24.27,6.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.24-376.14l17.24-17.15c3.97-19.16-20.31-23.48-23.64-7.18l6.4,24.33Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.16-369.03",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.6-376.55l23.48,6.32c18.57-6.17,10.14-29.34-5.64-24.05l-17.84,17.73Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.11-376.53l6.27,23.5c14.63,13,30.48-5.89,18.01-16.91l-24.28-6.59Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.74-376.12l-17.32,17.07c-4.06,19.15,20.2,23.57,23.6,7.29l-6.29-24.36Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.97-376.55l-23.44-6.46c-18.61,6.06-10.32,29.28,5.49,24.09l17.95-17.63Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1220.44,
    y1: -376.15,
    x2: 1208.46,
    y2: -372.29,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.64-375.54l-11.44,5.55c-3.39,1.43-5.07-3.78-1.48-4.6,0,0,12.53-2.17,12.53-2.17.72-.13,1.05.91.39,1.22h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1221.54,
    y1: -377.65,
    x2: 1212.28,
    y2: -385.82,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.12-377.17l-10.43-6.84c-2.98-2.18.66-6.31,3.2-3.62,0,0,8.08,9.5,8.08,9.5.49.54-.26,1.37-.85.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1221.52,
    y1: -377.22,
    x2: 1219.14,
    y2: -362.97,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.15-377.11l-.63,14.53c-.33,3.59-5.62,2.72-4.76-.8,0,0,4.13-13.95,4.13-13.95.21-.72,1.3-.53,1.26.21h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1222.59,
    y1: -376.14,
    x2: 1233.53,
    y2: -366.56,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.01-376.62l12.11,8.25c2.89,2.15-.66,6.21-3.18,3.63,0,0-9.77-10.92-9.77-10.92-.51-.54.25-1.39.84-.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1222.35,
    y1: -377.91,
    x2: 1226.71,
    y2: -389.73,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.75-378.13l2.7-12.44c.96-3.55,6.11-1.65,4.53,1.67,0,0-6.03,11.21-6.03,11.21-.34.65-1.36.27-1.2-.44h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1224.26,
    y1: -377.43,
    x2: 1236.32,
    y2: -379.27,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.16-378.07l11.79-3.59c3.59-.89,4.42,4.55.73,4.77,0,0-12.33.09-12.33.09-.73.01-.89-1.06-.19-1.26h0Z",
    fill: "#7db5a9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1147.98-256.01",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.29-230.58l-8.12-24.41c-16.27-12.79-31.8,8.16-17.94,19l26.05,5.41Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.6-230.15l17.08-19.23c2.94-20.49-22.97-23.46-25.42-6.03l8.35,25.27Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.42-224.34",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.01-230.68l25.2,5.14c19.2-7.73,8.79-31.64-7.52-25.02l-17.68,19.89Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.49-230.63l8.15,24.39c16.29,12.77,31.79-8.21,17.91-19.03l-26.06-5.37Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.07-230.1l-17.17,19.16c-3.04,20.48,22.86,23.57,25.39,6.15l-8.23-25.3Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.29-230.58l-25.17-5.29c-19.25,7.61-8.98,31.58,7.37,25.07l17.8-19.78Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1154.7,
    y1: -230.05,
    x2: 1142.31,
    y2: -225.19,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.94-229.45l-11.75,6.51c-3.28,1.61-5.26-3.45-1.76-4.5,0,0,13.04-3.2,13.04-3.2.72-.18,1.12.84.47,1.19h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1155.76,
    y1: -231.7,
    x2: 1145.46,
    y2: -239.73,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.37-231.2l-11.4-6.62c-3.07-1.99.27-6.3,2.97-3.81,0,0,9.22,9.42,9.22,9.42.53.51-.17,1.39-.79,1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1155.77,
    y1: -231.25,
    x2: 1154.19,
    y2: -216.06,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.4-231.18l.18,15.37c-.13,3.58-5.42,3.04-4.8-.5,0,0,3.35-15.01,3.35-15.01.16-.73,1.27-.62,1.27.13h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1156.97,
    y1: -230.18,
    x2: 1169.14,
    y2: -220.78,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.36-230.69l13.26,8c2.98,1.99-.27,6.2-2.95,3.82,0,0-11.09-10.81-11.09-10.81-.55-.51.16-1.41.78-1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1156.6,
    y1: -232.04,
    x2: 1160.44,
    y2: -244.8,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.98-232.22l2.14-13.28c.76-3.57,5.96-2.01,4.62,1.39,0,0-5.54,12.25-5.54,12.25-.3.68-1.35.36-1.22-.37h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1158.65,
    y1: -231.66,
    x2: 1171.26,
    y2: -234.39,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.51-232.28l12.23-4.46c3.5-1.08,4.66,4.25,1.02,4.72,0,0-12.98.99-12.98.99-.73.06-.96-1.01-.27-1.25h0Z",
    fill: "#7db5a9"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.49-151.85c4.21,1.19,14.98-13.68,13.86-25.79-.12-1.3-1.57-2.1-2.85-2.09-7.35.04-16.44,7.9-22.67,14.88",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1211.74-39.01c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1201.13,
    y1: -41.11,
    x2: 1219.57,
    y2: -49.17,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.93-41.57c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1200.35,
    y1: -41.24,
    x2: 1216.27,
    y2: -61.34,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.96-41.55c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1200.66,
    y1: -39.91,
    x2: 1226.72,
    y2: -37.4,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.71-40.41c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M868.21-45.58c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 857.6,
    y1: -47.68,
    x2: 876.05,
    y2: -55.73,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.4-48.14c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 856.82,
    y1: -47.81,
    x2: 872.74,
    y2: -67.9,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.43-48.12c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 857.13,
    y1: -46.48,
    x2: 883.19,
    y2: -43.97,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.18-46.98c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.21-150.14c1.83-6.66,7.22-13.11,13.86-15.34.31-.09.64.08.73.39-1.04,6.7-7.62,13.3-13.85,15.62-.41.15-.85-.25-.74-.67h0Z",
    fill: "#7db5a9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.32-149.72c-2.87-8.58-.52-19.78,6.54-25.72.27-.22.66-.17.88.1,2.82,6.83,1.24,13.92-1.99,20.16-.31.65-4.55,7.43-5.44,5.46h0Z",
    fill: "#7db5a9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.48-148.94c5.99-6.5,16.56-10.5,25.31-8.48.32.08.51.41.43.72-5.37,7.01-16.91,10.31-25.42,8.7-.42-.08-.6-.63-.32-.95h0Z",
    fill: "#7db5a9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1116.71-129.29",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.38-159.51c-3.11,9.7-2.96,20,.44,30.89,3.16.53,6.57,1.95,10.22,4.22l1.67-9.78c2.09.96,4.51,2.98,7.11,5.56,1.76-1.18,3-6.12,4.22-11.22-5.83-8.43-13.51-15.17-23.67-19.67Z",
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.71-129.29c11.92,1.55,17.92,6.82,28.89,20.17.08.09,0,.24-.12.22-9.87-1.49-21.96-9.19-28.77-20.4Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.6-125.96c.38-7.1,1.56-13.08,4.44-16.67,5.92,9.35,4.73,20.75.02,33.15-.05.13-.24.1-.25-.04-.15-9.92-3.65-18.49-13.11-24.66-1.29,3.14-1.47,6.78-1.11,10.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.71-128.62c-2.56-11.01-3.04-22.09-.11-30.89,8.4,2.24,18.36,10.03,24.22,18.83",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.16-234.35c-5.3,6.33-25,16.17-32.83,17",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1264.18-235.57c5.04,2.51,17.64-9.84,16.05-24.33-.14-1.25-1.52-1.9-2.78-2.05-8.29-.99-19.55,7.37-23.76,15.81",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1253.59,
    y1: -233.34,
    x2: 1267.4,
    y2: -247.98,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.23-233.68c1.86-6.51,7.22-12.67,13.8-14.65.32-.08.64.11.72.42-1.11,6.58-7.61,12.82-13.8,14.91-.41.14-.84-.27-.73-.69h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1252.83,
    y1: -233.15,
    x2: 1259.58,
    y2: -257.88,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.35-233.28c-2.79-8.38-.35-19.17,6.75-24.73.28-.21.68-.15.89.13,3.45,8.35-.01,19.08-6.68,24.87-.32.27-.83.13-.96-.26h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1253.63,
    y1: -232.05,
    x2: 1278.59,
    y2: -239.96,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.48-232.53c5.93-6.35,16.41-10.12,24.96-7.91.32.09.5.42.41.74-5.38,6.88-16.69,9.91-25.07,8.13-.42-.09-.59-.64-.3-.95h0Z",
    fill: "#7db5a9"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1263.05-444.82c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1260.95,
    y1: -433.97,
    x2: 1252.63,
    y2: -452.77,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49-433.76c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1260.82,
    y1: -433.17,
    x2: 1240.19,
    y2: -449.34,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.51-432.78c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1262.18,
    y1: -433.49,
    x2: 1264.64,
    y2: -460.13,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.68-433.54c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M831.47-227.73c4.93-2.98,1.17-20.6-12.22-27.16-1.16-.57-2.48.27-3.29,1.27-5.4,6.61-4.35,20.9.63,29.15",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 827.6,
    y1: -217.38,
    x2: 822.51,
    y2: -237.3,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.11-217.25c-4.54-5.2-6.91-13.16-5.09-19.93.1-.31.42-.48.73-.39,5.01,4.58,6.83,13.59,5.32,20.07-.1.43-.68.57-.97.25h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 827.34,
    y1: -216.61,
    x2: 809.68,
    y2: -235.98,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.97-216.27c-8.67-2.24-16.66-10.28-17.66-19.37-.03-.35.23-.65.57-.68,7.2,1.35,12.19,6.49,15.57,12.56.37.61,3.64,7.84,1.52,7.48h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 828.73,
    y1: -216.7,
    x2: 835.58,
    y2: -242.56,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.25-216.83c-2.13-8.6.35-19.64,6.84-25.86.24-.22.62-.2.84.04,2.33,6.9.47,13.98-2.55,20.26-.34.66-4.28,7.64-5.13,5.56h0Z",
    fill: "#7db5a9"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M798.71-122.07c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 796.61,
    y1: -111.22,
    x2: 788.29,
    y2: -130.02,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.16-111.01c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 796.48,
    y1: -110.42,
    x2: 775.85,
    y2: -126.59,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.18-110.03c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 797.84,
    y1: -110.74,
    x2: 800.3,
    y2: -137.38,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.35-110.79c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1294.02-490.38c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1288.05,
    y1: -480.86,
    x2: 1287.08,
    y2: -501.75,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.55-480.83c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1287.63,
    y1: -480.15,
    x2: 1274.04,
    y2: -503.06,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.2-479.89c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1289.04,
    y1: -479.96,
    x2: 1301.15,
    y2: -504.31,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.59-480.18c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h0Z",
    fill: "#7db5a9"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M892.05-318.07c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 886.07,
    y1: -308.55,
    x2: 885.1,
    y2: -329.44,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.57-308.53c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 885.66,
    y1: -307.84,
    x2: 872.06,
    y2: -330.75,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.23-307.59c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 887.06,
    y1: -307.65,
    x2: 899.17,
    y2: -332,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.61-307.87c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h0Z",
    fill: "#7db5a9"
  })))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88,155.4c49.56-19.78,83.78-67.78,92.44-111.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower1);
export default __webpack_public_path__ + "static/media/flower1.61a20a3a864836c7c8cf6547b294fef5.svg";
export { ForwardRef as ReactComponent };